<template>
    <div :class="darkmode ? 'main-content container body-content main mt-4 bg-dark text-light' : 'main-content container body-content main mt-4'">
        <img src="../assets/logos/schullogo-red.png" 
            alt="BSZ Wiesau" 
            class="img-responsive mt-n1 mb-2" 
            style="margin:1em 0 2em 0" width="200"
        >
        <br>
        <img src="../assets/logos/mitfahrzentrale-logo.png" 
            alt="BSZ Wiesau" 
            class="img-responsive mt-n1 mb-2" 
            style="margin:1em 0 2em 0; filter: invert(22%) sepia(86%) saturate(1902%) hue-rotate(340deg) brightness(100%) contrast(101%);" 
            width="330"
        >
        <h4>Herausgeber</h4>

        <strong>Staatliches Berufliches Schulzentrum Wiesau</strong>
        <address> Pestalozzistraße 2, 95676 Wiesau</address>


        <h4>Entwickelt von</h4>
        <p>Thomas Frischholz<br>Kean Kökten</p>

        <h4>Ansprechpartner</h4>
        <p>Thilo Bareuther</p>

        <h4>Kontakt</h4>
        <p>
            Telefon: +49 (0)9634 / 92 03-0<br>
            Telefax: +49 (0)9634 / 8282<br>
            E-Mail: info@bs-wiesau.de <br>
            Thomas Metzler, OStD (Schulleiter)
        </p>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    name: "Ueber",
    computed: mapGetters(['darkmode'])
}
</script>